import {
  getListingChannelId,
  matchesChannelId,
} from '../products/helpers/channelHelpers';

const emptyUi = {
  selectedChannelByProduct: {},
  activeTabByProductChannel: {},
  fetching: {
    listingAssets: {},
    listingVariantAssets: {},
    masterAssets: {},
    masterVariantAssets: {},
  },
};

const buildListingProductFromEntity = (listing) => {
  if (!listing) return null;

  const { masterProductId, ...listingProduct } = listing;
  return listingProduct;
};

const buildProductChannelFromListing = ({
  listing,
  ui = emptyUi,
  masterProductId,
}) => {
  const channelId = getListingChannelId(listing);
  const listingProduct = buildListingProductFromEntity(listing);
  const activeTab = ui.activeTabByProductChannel?.[masterProductId]?.[channelId]
    ?? listing.listingStatus;

  const channelEntry = {
    listingStatus: listing.listingStatus,
    activeTab,
    listingProduct,
  };

  if (listing.salesChannelId) {
    channelEntry.salesChannelId = String(listing.salesChannelId);
  } else if (listing.salesChannel) {
    channelEntry.name = listing.salesChannel;
  }

  if (listing.externalId != null) {
    channelEntry.externalId = listing.externalId;
  }

  if (listing.syncedAt != null) {
    channelEntry.syncedAt = listing.syncedAt;
  }

  return channelEntry;
};

export const buildProductListingsMap = (entities, ui, masterProductId) => {
  const map = {};

  Object.values(entities?.listings || {}).forEach((listing) => {
    if (listing?.masterProductId !== masterProductId) return;

    const channelId = getListingChannelId(listing);
    if (!channelId) return;

    map[channelId] = buildProductChannelFromListing({
      listing,
      ui,
      masterProductId,
    });
  });

  return map;
};

const findListingVariantEntity = (entities, masterVariantId, channelId) => (
  Object.values(entities?.listingVariants || {}).find(
    (listingVariant) => (
      listingVariant?.masterVariantId === masterVariantId
      && matchesChannelId(listingVariant, channelId)
    ),
  ) ?? null
);

const buildVariantChannelEntryFromEntity = (listingVariant) => {
  if (!listingVariant) return null;

  const channelEntry = { ...listingVariant };

  if (listingVariant.salesChannelId) {
    channelEntry.salesChannelId = String(listingVariant.salesChannelId);
  } else if (listingVariant.salesChannel) {
    channelEntry.name = listingVariant.salesChannel;
  }

  return channelEntry;
};

export const getDenormalizedVariantChannelEntry = (
  entities,
  masterProduct,
  masterVariantId,
  channelId,
) => {
  const listingVariant = findListingVariantEntity(entities, masterVariantId, channelId);

  if (!listingVariant) {
    return null;
  }

  return buildVariantChannelEntryFromEntity(listingVariant);
};
